import { put, call } from 'redux-saga/effects';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import { BACKEND_URL, DEFAULT_ITEMS_OF_PAGE } from '../../../configs';
import makeRequest, { getBodyJson } from '../../../utils/makeRequest';
import processError from '../../../utils/processError';
import { OK } from '../../../configs/serverStatusCodes';
import {
  loadReportsListBegin,
  loadReportsListSuccessful,
  loadReportsListFailed,
} from '../actions';

export default function* loadReportsList(action) {
  const { payload = {} } = action;
  const {
    limit = DEFAULT_ITEMS_OF_PAGE,
    page = 1,
  } = payload;

  const requestPool = {
    limit,
    page,
  };

  try {
    const url = `${BACKEND_URL}/proxy/report/v1/reports`;
    yield put(loadReportsListBegin());
    const dataResponse = yield makeRequest(url, requestPool, action, 'GET', true);
    const body = yield getBodyJson(dataResponse, { data: [], meta: {} });

    if (dataResponse.status === OK) {
      const normalized = {
        result: body?.data || [],
        meta: body?.meta || {},
      };

      yield put(loadReportsListSuccessful(normalized));
      yield call(resolveActionPromise(action, normalized));
    } else {
      yield put(loadReportsListFailed());
      yield call(rejectActionPromise(action, body));
    }
  } catch (e) {
    yield put(loadReportsListFailed());
    yield call(rejectActionPromise(action, e));
    yield processError(e);
  }
}
